/* Components */
import { Product } from "@/store/wallet/product.model";
import { ProductsGrid } from "../ProductsGrid/ProductsGrid";

/* Utils */
import { useResponsive } from "@/utils/useResponsive";
import { getCustomComponent } from "@/utils/custom-components.utils";
import { useBrandConfig } from "@/utils/useBrandConfig";
import { Suspense, useMemo } from "react";

export type ProductsGridProps = {
  products: Product[];
  isCarouselView: boolean;
}

export const Products = ({ products, isCarouselView }: ProductsGridProps) => {
  const { isMobile, isTablet } = useResponsive();
  const { name } = useBrandConfig();

  const ProductsCarousel = useMemo(() => getCustomComponent({
    brandName: name,
    folder: 'ProductsCarousel',
  }), [name]);

  return isMobile || isTablet
    ? <Suspense>
      <ProductsCarousel products={products} isCarouselView={isCarouselView} />
    </Suspense>
    : <ProductsGrid products={products} />
}